module.exports = __webpack_public_path__ + "media/images/icon__burger-menu@3x-d525c1c1853fe68ff26762082d05b9e6.png";